import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

const CardGroup = ({ legend, colWidth, children, smallMobileColWidth }) => {
    // Sometimes we need the col width to be set at a smaller screen size 
    // than col--sm. This will add a little flexibility. Example StoreListItems.js 
    const _smallMobileColWidth =
        smallMobileColWidth && smallMobileColWidth <= 12
            ? smallMobileColWidth
            : 12 / Math.min(children.length, 4);
    const _colWidth =
        colWidth && colWidth <= 12
            ? colWidth
            : 12 / Math.min(children.length, 4);
    const list = children.map((card, i) => {
        return (
            card && (
                <div
                    key={i}
                    className={cx(
                        `col col--12 col--sm-${_colWidth}`,
                        smallMobileColWidth &&
                            `col--xsm-${_smallMobileColWidth}`,
                    )}
                >
                    {card}
                </div>
            )
        );
    });
    return (
        <fieldset>
            <legend className="-visually-hidden">{legend}</legend>
            <div className="grid">{list}</div>
        </fieldset>
    );
};

CardGroup.propTypes = {
    legend: PropTypes.string.isRequired,
    colWidth: PropTypes.number,
    smallMobileColWidth: PropTypes.number,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]).isRequired,
};

export default CardGroup;
